module.exports = __webpack_public_path__ + "img/keting.227d8a86.png";